import serviciosV2Client from "../../../helpers/serviciosV2Client"

const ANALYTICS = "analytics/receptores"
const EXPORT_BASE = "export/receptores/perfil-360"

const cleanParams = obj =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined),
  )

const baseFiltros = ({
  nitemisor, fecha_inicio, fecha_fin,
  campo_fecha, sucursal, excluir_consumidor_final,
}) =>
  cleanParams({
    nitemisor, fecha_inicio, fecha_fin,
    campo_fecha, sucursal,
    excluir_consumidor_final: excluir_consumidor_final ? "true" : undefined,
  })

/**
 * Catálogo paginado con RFM por cada cliente.
 * Filtros opcionales: segmento, order_by (monetary|recency|frequency|ticket_promedio|nombre), order_dir.
 */
export const getPerfilCatalogo = ({
  segmento, order_by, order_dir, limit = 100, offset = 0,
  ...filtros
}) =>
  serviciosV2Client.get(`${ANALYTICS}/perfil-360`, {
    params: cleanParams({
      ...baseFiltros(filtros),
      segmento, order_by, order_dir, limit, offset,
    }),
  })

/**
 * Drill-down 360° de UN cliente — los 12 bloques en una sola respuesta.
 */
export const getPerfilDetalle = (nitReceptor, filtros) =>
  serviciosV2Client.get(`${ANALYTICS}/${encodeURIComponent(nitReceptor)}/perfil-360`, {
    params: baseFiltros(filtros),
  })

/**
 * Descarga el catálogo como CSV o XLSX (streaming del back).
 * Respeta Content-Disposition para el filename.
 */
export const descargarPerfilExport = async ({
  segmento, formato = "xlsx", ...filtros
}) => {
  const params = cleanParams({
    ...baseFiltros(filtros),
    segmento,
  })

  let response
  try {
    response = await serviciosV2Client.get(`${EXPORT_BASE}.${formato}`, {
      params,
      responseType: "blob",
      timeout: 600000,
    })
  } catch (err) {
    if (err.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text()
        const json = JSON.parse(text)
        throw new Error(json.error || json.message || "Error al exportar.")
      } catch (parseErr) {
        if (parseErr instanceof Error && parseErr.message.startsWith("Error al exportar")) throw parseErr
      }
    }
    throw err
  }

  const cd = response.headers["content-disposition"] || ""
  const match = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i)
  const filename = match
    ? decodeURIComponent(match[1])
    : `perfil_360_${filtros.nitemisor}_${new Date().toISOString().split("T")[0]}.${formato}`

  const contentType = response.headers["content-type"] ||
    (formato === "xlsx"
      ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      : "text/csv;charset=utf-8;")

  const blob = new Blob([response.data], { type: contentType })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)

  return {
    totalRows: Number(response.headers["x-total-rows"]) || null,
    totalSheets: Number(response.headers["x-total-sheets"]) || null,
    filename,
  }
}
